import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {LogsAbstractService} from "./logs-abstract.service";

@Injectable()
export class MailLogsService extends LogsAbstractService {
  constructor(protected http: HttpClient) {
    super(http, 'email_logs');
  }
}
